import { Link } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import { Alert } from '@material-ui/lab';
import { useOrg } from 'components/OrgProvider';
import { useOrgUser } from 'components/OrgUserProvider';
import { useFreeTrial, useSubscriptionAccess, useSubscriptionStatus } from 'hooks/useSubscriptionStatus';
import { OrgRoles } from "models/OrgRoles";
import { orgUserIdFrom } from 'models/OrgUser';
import { Paths } from 'Paths';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { PaymentManager } from './PaymentManager';

type NoSubscriptionAlertProps = {
    showPaymentManager?: boolean
}

export function TrialAlert() {
    const [org] = useOrg()
    const [orgUser] = useOrgUser()
    const [trial, loadingTrial, daysLeft] = useFreeTrial()
    const [subscriptionActive, loadingSubscription] = useSubscriptionStatus()
    const isOwner = orgUser?.data.orgRoles.map[OrgRoles.FlatEnum.OWNER]
    return (
        (org && trial && !loadingTrial && !subscriptionActive && !loadingSubscription) ? (
            <>
                <ListItem>
                    <Alert style={{ width: '100%' }} severity={daysLeft < 4 ? "warning" : "info"}>
                        {'Det gjennstår ' + daysLeft + ' dager av din gratis prøveperiode. Når denne utgår vil medlemmer av organisasjonen ikke være i stand til å opprette nye anbud, utkast og prisfelter fram til '}
                        {isOwner ? <>en eier <Link component={RouterLink} to={Paths.MY_ORG}>{'starter et abonnement'}</Link></> : null}
                        {(!isOwner && org.data.owner.appUser) ? <><Link component={RouterLink} to={Paths.ORG_USERS + '/' + orgUserIdFrom(org.data.id, org.data.owner.appUser.id)}>{'en eier'}</Link> starter et abonnement</> : null}
                    </Alert>
                </ListItem>
            </>
        ) : null
    )
}

export function NoSubscriptionAlert({ showPaymentManager }: NoSubscriptionAlertProps) {
    const [org] = useOrg()
    const [orgUser] = useOrgUser()
    const [subscriptionActive, loadingSubscription] = useSubscriptionAccess()
    const isOwner = orgUser?.data.orgRoles.map[OrgRoles.FlatEnum.OWNER]
    return (
        (org && !subscriptionActive && !loadingSubscription) ? (
            <>
                <ListItem>
                    <Alert style={{ width: '100%' }} severity="warning">
                        {'Organisasjonen har ingen aktive abonnementer. Medlemmer av organisasjonen vil ikke være i stand til å opprette nye anbud, utkast og prisfelter fram til '}
                        {isOwner ? <>en eier <Link component={RouterLink} to={Paths.MY_ORG}>{'starter et abonnement'}</Link></> : null}
                        {(!isOwner && org.data.owner.appUser) ? <><Link component={RouterLink} to={Paths.ORG_USERS + '/' + orgUserIdFrom(org.data.id, org.data.owner.appUser.id)}>{'en eier'}</Link> starter et abonnement</> : null}
                    </Alert>
                </ListItem>
                {(isOwner && showPaymentManager) ? <PaymentManager /> : null}
            </>
        ) : null
    )
}
